"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JournalsService = void 0;
class JournalsService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    getJournals({ cursor, query, rows, mailto, offset, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/journals',
            query: {
                'cursor': cursor,
                'query': query,
                'rows': rows,
                'mailto': mailto,
                'offset': offset,
            },
        });
    }
    getJournals1({ issn, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/journals/{issn}',
            path: {
                'issn': issn,
            },
            errors: {
                404: `The journal identified by {issn} does not exist.`,
            },
        });
    }
    getJournalsWorks({ issn, rows, order, facet, sample, sort, offset, mailto, select, query, filter, cursor, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/journals/{issn}/works',
            path: {
                'issn': issn,
            },
            query: {
                'rows': rows,
                'order': order,
                'facet': facet,
                'sample': sample,
                'sort': sort,
                'offset': offset,
                'mailto': mailto,
                'select': select,
                'query': query,
                'filter': filter,
                'cursor': cursor,
            },
        });
    }
}
exports.JournalsService = JournalsService;
//# sourceMappingURL=JournalsService.js.map